/**
 * @module experience/billing-details
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */

export const ACCOUNT_LANDING_MODULE_COMPONENTS = {
  ACCOUNT_LANDING_MODULE_NAME: 'Account Landing Module',
  ACCOUNT_LANDING_COMPONENT: 'AccountLandingComponent',
  ACCOUNT_LANDING_SERVICE: 'AccountLandingService',
};

export const ACCOUNT_LANDING_CONSTANTS = {
  UNLIMITED: 'UNLIMITED',
  DUPLICATE: 'duplicate',
  DUPLICATE_SYMBOL: 'D',
  VIRTUAL_SYMBOL: 'V',
  ADDED: 'added',
  REMOVED: 'removed',
  PPU: 'ppu',
  PREPAID: 'PREPAID',
  PLANS: 'plans',
  MANAGE_PENDING_ORDERS: 'manage pending orders',
  LINE_LANDING: '/line-landing',
  BROWSE_DEVICES: '/browse-phones',
  FALSE: 'false',
  LOAD_ACCOUNT_LANDING: 'loadAccountLanding',
  DEFAULT: 'default',
  SECONDARY_LINK: 'secondaryLink',
  ORDER_STATUS_INPROCESS: 'INPROCESS',
  ORDER_STATUS_RECEIVED: 'RECEIVED',
  isWeb: 'web',
  MANAGEADDON: 'MANAGEADDON',
  PRIMARY: 'Primary',
  MIGRATION_THRESHHOLD: '60',
  ANNUAL_DATA_PASS: 'yearlyusage',
  SESSION_PASS_DATA: 'sessionpassdata',
  CANCELLED: 'CANCELLED',
  SUSPENDED: 'SUSPENDED',
};

export const ORDER_TYPES = ['MANAGEADDON', 'MANAGERATEPLAN', 'ACTIVATION', 'ADDALINE', 'UPGRADE'];

export const ALERT_CONSTANTS = {
  NUMBER_OF_ALERTS_TO_SHOW: 3,
};

/**
 * Enum values for billing type
 */
export enum BillingTypeEnum {
  PREPAID,
  POSTPAID,
}
